module.exports = __webpack_public_path__ + "img/personal-center-stu-del.c2e1455c.svg";